import {Component} from 'react';
import {doubleToStringMonthly} from '../../../objects/CommonUse/double_functions';

class SavingsChangeConfirmCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false, 
            selected: false
        };
        this.determineDisplayInfo()
    }

    determineDisplayInfo(){
        this.transferAmt = "";
        if (this.props.tableInfo.transferFee === true){
            this.transferAmt = "***" 
        }
        this.oneTimeAmt = doubleToStringMonthly(this.props.tableInfo.oneTimeAmt);
        this.transferAmt += doubleToStringMonthly(this.props.tableInfo.transferAmt);
        this.amountClass = "text-right p-0 " + this.props.tableInfo.rowClass;
        this.firstColumnClass = "text-left " + this.props.tableInfo.rowClass;
    }
   
    render() {
        
    return <>
        <tr className="">
            <th className={this.firstColumnClass}>{this.props.tableInfo.savingsType}</th>
            <td className={this.amountClass}>{this.oneTimeAmt}</td>
            <td className={this.amountClass}>{this.transferAmt}</td>
            <td className={this.amountClass}>
                {doubleToStringMonthly(this.props.tableInfo.currentMonthlyAmt)}</td>
            <td className={this.amountClass}>{doubleToStringMonthly(this.props.tableInfo.newMonthlyAmt)}</td>
            <td className={this.amountClass}>{this.props.tableInfo.percent}%</td>
        </tr>

    </>
    }
}

export default SavingsChangeConfirmCard;